import type { HintKey, HintParams } from './index'

export interface AddHintAction {
  type: 'ADD_HINT'
  payload: HintParams
}
export const addHint = (hintParams: HintParams): AddHintAction => ({
  type: 'ADD_HINT',
  payload: hintParams,
})
export interface RemoveHintAction {
  type: 'REMOVE_HINT'
  payload: {
    hintKey: HintKey
    // persist hint removal across sessions
    rememberDismissal: boolean
  }
}
export const removeHint = (
  hintKey: HintKey,
  rememberDismissal: boolean
): RemoveHintAction => ({
  type: 'REMOVE_HINT',
  payload: {
    hintKey,
    rememberDismissal,
  },
})
export interface ClearAllHintDismissalsAction {
  type: 'CLEAR_ALL_HINT_DISMISSALS'
}
export const clearAllHintDismissals = (): ClearAllHintDismissalsAction => ({
  type: 'CLEAR_ALL_HINT_DISMISSALS',
})
